module.exports = __webpack_public_path__ + "img/environment_outdoor3.6472728d.jpg";